<template>
  <svg @click.prevent='toggle()' :class='{heart: true, "hearted": hearted }' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.12 27.53">
    <path class="light" d="M14.06 27.53A13.77 13.77 0 1 0 0 13.76a13.91 13.91 0 0 0 14.06 13.77"/>
    <path class="dark" d="M19.47 14.97a2.84 2.84 0 0 0 0-4.23 3.39 3.39 0 0 0-4.55 0l-.86.8-.85-.8a3.39 3.39 0 0 0-4.55 0 2.84 2.84 0 0 0 0 4.23c.07.08.38.36.85.8L14.06 20l4.55-4.23.85-.8"/>
  </svg>
</template>

<style scoped>
  svg {
    height: 1.75em;
    vertical-align: middle;
    display: inline-block;
  }

  svg.hearted .light {
    fill: var(--blue);
  }

  svg.hearted .dark {
    fill: var(--mint);
  }
  .light {fill: var(--mint);}
  .dark {fill: var(--blue);}
</style>

<style>
  a#My-Story-Collection-Tag {
    position: relative;
    display: block;
    padding-left: 2.25rem;
  }
  a#My-Story-Collection-Tag::before {
    display: block;
    position: absolute;
    left: -0.075em;
    top: 0;
    height: 2.1em;
    width: 2.05em;
    content:url('data:image/svg+xml,<svg style="height: 1rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.12 27.53"><path fill="white" opacity="0.7" d="M14.06 27.53A13.77 13.77 0 1 0 0 13.76a13.91 13.91 0 0 0 14.06 13.77"/><path fill="%232c93a0" d="M19.47 14.97a2.84 2.84 0 0 0 0-4.23 3.39 3.39 0 0 0-4.55 0l-.86.8-.85-.8a3.39 3.39 0 0 0-4.55 0 2.84 2.84 0 0 0 0 4.23c.07.08.38.36.85.8L14.06 20l4.55-4.23.85-.8"/></svg>')
  }
  .light {fill: var(--mint);}
  .dark {fill: var(--blue);}
</style>

<script>
import mixins from '.././mixins.js';
import { mapState } from 'vuex';
import VueCookies from 'vue-cookies';
export default {
  props: ['uid', 'cookie', 'hearted'],
  mixins: [mixins], //kirby(), urltopath(), etc
  created: function() {
    if(!this.$store.state.cookies.loaded && this.cookie){
      this.$store.commit('setupCookie', this.cookie);
    }
    //
    this.updateHeart()
  },
  computed: {
    ...mapState({allHeartedStories: state => state.cookies.hearted}),
  },
  methods: {
    updateHeart() {
      //console.log(this.partOfTheHearted(this.uid));
      this.$emit('update:hearted', this.partOfTheHearted(this.uid));
    },
    partOfTheHearted(uid){
      return (this.allHeartedStories.indexOf(uid) > -1 );
    },
    toggle: function() {
      if(this.partOfTheHearted(this.uid)) {
        this.$store.commit('removeFromCookie', this.uid);
        this.updateHeart();
      } else {
        this.$store.commit('setCookieValue', this.uid);
        this.updateHeart();
      }
    }
  }
}
</script>
